import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

type PageIntroHeaderProps = {
  title: string;
  description: string;
  actions?: ReactNode;
  className?: string;
  copyClassName?: string;
  actionsClassName?: string;
};

export function PageIntroHeader({
  title,
  description,
  actions,
  className,
  copyClassName,
  actionsClassName,
}: PageIntroHeaderProps) {
  return (
    <section className={cn('dashboard-page__intro page-title-block', className)}>
      <div className={cn('page-section-header__copy', copyClassName)}>
        <h1 className="page-title-block__title">{title}</h1>
        <p className="page-title-block__description">{description}</p>
      </div>

      {actions ? <div className={cn('dashboard-overview-card__actions', actionsClassName)}>{actions}</div> : null}
    </section>
  );
}